import { useEffect, useState } from 'react';

export function CountdownCircle({
  duration,
  size = 50,
  strokeWidth = 5,
  color = '#96c11f',
  bgColor = '#ffffff',
  onComplete,
  className = '',
}) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete?.();
      return;
    }

    const startTime = Date.now();
    const endTime = startTime + timeLeft * 1000;

    const timer = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(0, endTime - now);
      const remainingSeconds = Math.ceil(remaining / 1000);
      const currentProgress = (remaining / (duration * 1000)) * 100;

      setTimeLeft(remainingSeconds);
      setProgress(currentProgress);

      if (remaining <= 0) {
        clearInterval(timer);
      }
    }, 16); // ~60fps for smooth animation

    return () => clearInterval(timer);
  }, [duration, onComplete]);

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold${
        className ? ` ${className}` : ''
      }`}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: `conic-gradient(${color} ${progress * 3.6}deg, ${bgColor} ${
          progress * 3.6
        }deg)`,
        padding: strokeWidth,
      }}
    >
      <span
        className={`flex items-center justify-center rounded-full bg-white w-full h-full${
          timeLeft === 0 ? ' invisible' : ''
        }`}
      >
        {timeLeft}
      </span>
    </span>
  );
}
